// eslint-disable-next-line no-restricted-imports
import { Tabs } from "@packages/ds";

import Root from "./Root";

// Create a namespaced export with our analytics-enhanced Root
const ConsoleTabsNamespace = {
  Root, // Our wrapped version with analytics
  List: Tabs.List,
  Trigger: Tabs.Trigger,
  TriggerIcon: Tabs.TriggerIcon,
  TriggerLabel: Tabs.TriggerLabel,
  Content: Tabs.Content
};

// Export each component individually as well
export const { List, Trigger, TriggerIcon, TriggerLabel, Content } =
  ConsoleTabsNamespace;
export { Root };

// Default export for namespace-style imports
export default ConsoleTabsNamespace;
